import { render, staticRenderFns, recyclableRender, components } from "./mescroll-body.vue?vue&type=template&id=0bfd0ead&scoped=true&filter-modules=eyJ3eHNCaXoiOnsidHlwZSI6InNjcmlwdCIsImNvbnRlbnQiOiIiLCJzdGFydCI6MzIxNywiYXR0cnMiOnsic3JjIjoiLi93eHMvd3hzLnd4cyIsIm1vZHVsZSI6Ind4c0JpeiIsImxhbmciOiJ3eHMifSwiZW5kIjozMjE3fSwicmVuZGVyQml6Ijp7InR5cGUiOiJyZW5kZXJqcyIsImNvbnRlbnQiOiIiLCJzdGFydCI6MzM1MCwiYXR0cnMiOnsibW9kdWxlIjoicmVuZGVyQml6IiwibGFuZyI6ImpzIn0sImVuZCI6MzQ0M319&"
import renderjs from "./mescroll-body.vue?vue&type=renderjs&module=renderBiz&lang=js&"
renderjs.__module = 'renderBiz'
export * from "./mescroll-body.vue?vue&type=renderjs&module=renderBiz&lang=js&"
import script from "./mescroll-body.vue?vue&type=script&lang=js&"
export * from "./mescroll-body.vue?vue&type=script&lang=js&"
import style0 from "./mescroll-body.vue?vue&type=style&index=0&id=0bfd0ead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd0ead",
  null,
  false,
  components,
  renderjs
)

/* custom blocks */
import block0 from "./wxs/wxs.wxs?vue&type=custom&index=0&blockType=script&issuerPath=D%3A%5Cphpstudy_pro%5CWWW%5CMuHeShop%5Cuniapp%5Ccomponents%5Cmescroll-uni%5Cmescroll-body.vue&module=wxsBiz&lang=wxs"
if (typeof block0 === 'function') block0(component)

export default component.exports